__turbopack_context__.v({
  "chip": "E2CLKq_chip",
  "container": "E2CLKq_container",
});
